import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import {FormBuilder, FormGroup, FormArray, FormControl, Validators} from "@angular/forms";
import {MessageService} from 'primeng/api';
import { StorageService } from 'src/app/services/storage.service';


interface City {
  name: string,
  code: string
}

@Component({
    selector: 'app-add-user',
    templateUrl: './add-user.component.html',
    styleUrls: ['./add-user.component.scss'],
    standalone: false
})
export class AddUserComponent implements OnInit {

  cities: City[];
 
  selectedCity!: City;
  selectedRole:any;
  selectedBranch:any;

  firstName: any;
  lastName : any;
  email : any;



  
  onFileSelected(event: any) {
    var file: File = event.target.files[0];
  
    // Perform further processing with the selected file
  }
  

  
  @Input() estampData: any = [];
  @Output() estampChange: EventEmitter<any> = new EventEmitter<[]>();
  
  states: any;
  selectedState:any;
  estampDetails : FormGroup;
  documentDetailsForm! : FormArray;
  estampLength: any;
  readOnlyName: any =[];
  submitted : boolean = false;
  showSigningDetails :boolean = false;
  showPartyDetails :boolean = true;
  public phonePattern: string = '[0-9]{10}';
  eSignProviderData =[];
  showPichainSign!:boolean;
  showDragDrop!:boolean;
  displaySigningPositions:any =[];
  signPlacementNomal = [
    {name: 'Pre-Defined', value: 'NORMAL'},
   {name: 'Custom  (Drag & Drop)', value: 'CUSTOM'},
  ];

  signPlacement = [
    {name: 'Pre-Defined', value: 'NORMAL'}
  ];

  signPages = [
    {name: 'ALL Pages', code: 'ALL'},
    {name: 'First Page Only', code: 'FIRST'},
    {name: 'Last Page Only', code: 'Last'},
  ];
  signMethod = [
    {name: 'Aadhaar', code: 'AADHAAR'},
    {name: 'Electronic', code: 'ELECTRONIC'},
    {name: 'DSC', code: 'DSC'},
  ];
  isEsigned: boolean = false;
  showWitnessDetails: boolean =false;
  showSignaotryDetails: boolean = false;
  showTemplatePage: boolean = false;
  showPaymentDetails: boolean = false;
  userRole: string;

  constructor(private router:Router, private formBuilder: FormBuilder, private messageService: MessageService, private storageService: StorageService) {


    this.estampDetails = this.formBuilder.group({
      documentDetailsForm: this.formBuilder.array([]),
   });


    this.cities = [
      {name: 'Rome', code: 'RM'},
      {name: 'London', code: 'LDN'},
      {name: 'Istanbul', code: 'IST'},
      {name: 'Paris', code: 'PRS'}
  ];
   }

  ngOnInit(): void {
    this.userRole = this.storageService.getRole() || '';
    this.addNewDetails();
  }

  gotoDashboard(){
    this.userRole === 'CLIENT'
      ? this.router.navigate(['doqfy/dashboard'])
      : this.router.navigate(['doqfy/admin-dashboard']);
  }
  nextStepSign(){
    this.sendEstampDetails();
    this.messageService.add({severity:'custom', summary: 'User added successfully!', detail: 'User added successfully.', icon: 'pi-check-circle'});
  }

  sendEstampDetails() {
    this.estampData = this.estampDetails.value;
    this.estampChange.emit(this.estampData);
  }


  savePersonalDetails(){

  }


  
  // *------------------------------- eStamp Details --------------------------------------------*/
  removeDetails(index: number) {
    this.documentDetailsArray().removeAt(index);
  }

  documentDetailsArray(): FormArray {
    return this.estampDetails.get("documentDetailsForm") as FormArray;
  }

  addNewDetails() {
    this.estampLength = this.estampDetails.controls['documentDetailsForm'].value.length;
    if(this.estampLength == 0){
       this.readOnlyName.push(false);
      this.documentDetailsArray().push(this.initDetails())
    } else if(this.estampDetails.controls['documentDetailsForm'].valid){
      this.readOnlyName.push(true);
      this.documentDetailsArray().push(this.repeatDetails())
    } else  {
      this.messageService.add({severity:'warn', summary: 'User Details', detail: 'Please fill User details before adding New'});
     
    }
   

  }

  initDetails() {
    return this.formBuilder.group({
      firstPartyName: new FormControl('',[Validators.required]),
      secondPartyName:new FormControl('',[Validators.required]),
      stampDutyPaidBy:new FormControl('',[Validators.required]),
      stampDutyValue:new FormControl(null,[Validators.required]),
      purposeOfStampDuty:new FormControl('',[Validators.required]),
      NoOfCopies :new FormControl(1,[Validators.required]),
     // articleNumber:new FormControl('',[Validators.required]),
     articleNumber:new FormControl(''),
      considerationPrice:new FormControl(null,[Validators.required]),
    });
  }

  repeatDetails(){
    return this.formBuilder.group({
      firstPartyName:   this.estampDetails.controls['documentDetailsForm'].value[0].firstPartyName,
      secondPartyName: this.estampDetails.controls['documentDetailsForm'].value[0].secondPartyName,
      // stampDutyPaidBy: new FormControl('',[Validators.required]),
      stampDutyPaidBy: this.estampDetails.controls['documentDetailsForm'].value[0].stampDutyPaidBy,
      stampDutyValue:new FormControl(null,[Validators.required]),
      purposeOfStampDuty:new FormControl('',[Validators.required]),
      NoOfCopies :new FormControl(1,[Validators.required]),
      // articleNumber:new FormControl('',[Validators.required]),
      considerationPrice:new FormControl(null,[Validators.required]),
    });
  }

  numberOnly(event: any) {
    const pattern = /[0-9\-]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
}
